import type { CatalogEntry } from '../types';

/**
 * Inbound webhooks (feature `17`) error codes + catalog. Covers the api's
 * unauthenticated provider push receivers — Gmail Pub/Sub push and Outlook
 * Graph change-notifications.
 *
 * Code shape is `17AAEE` (decimal, zero-padded):
 *   - `AA` = endpoint within the feature (`00` = feature-level / cross-endpoint).
 *   - `EE` = specific condition within that endpoint.
 *
 * The receivers ack (2xx) on every malformed / unknown-account / duplicate case
 * — this code is thrown ONLY on the authenticity gate, so a spoofed push is
 * rejected before any business logic runs:
 *   - `InvalidPubsubToken` — the Gmail push's OIDC bearer JWT failed
 *     verification (bad signature/audience/service-account or expired).
 *
 * The Outlook receiver has no error code: a bad per-entry `clientState` is
 * fast-acked by skipping just that entry (no throw), so nothing to catalog.
 *
 * Endpoint → `AA` map:
 *   gmailPush=01 (POST /webhooks/gmail/push).
 */
export const INBOUND_WEBHOOKS_CODES = {
  /** Gmail Pub/Sub push receiver (OIDC gate). AA=01. */
  GmailPush: {
    InvalidPubsubToken: '170101',
  },
} as const;

export const INBOUND_WEBHOOKS_CATALOG: Record<string, CatalogEntry> = {
  // ── Gmail Pub/Sub push ──
  '170101': { httpStatus: 401, message: 'Webhook request could not be verified.' },
};
